const getRedReason = (redMapping: any, redGroup: any, index: number) => {
    const reason = redMapping?.reason ?? redGroup?.reason;
    if (Array.isArray(reason)) {
        return reason[index] || reason[0] || '';
    }

    return reason || '';
};

/**
 * Internal-review analysis always renders evidence from the matching blue group.
 * Red data only supplies the review conclusion and reasoning fields.
 */
export const normalizeRedAnalysisMappingGroup = (redGroup: any, blueAllMappings: any[] = []) => {
    const blueIndex = Number(redGroup?.feature_index) - 1;
    const blueGroup = Number.isInteger(blueIndex) ? blueAllMappings[blueIndex] : null;
    const blueMappings = Array.isArray(blueGroup?.mappings) ? blueGroup.mappings : [];
    const redMappings = Array.isArray(redGroup?.mappings) ? redGroup.mappings : [];

    return {
        ...blueGroup,
        ...redGroup,
        reason: redGroup?.reason || '',
        mapping_label: redGroup?.mapping_label,
        review_action: redGroup?.review_action,
        review_analysis: redGroup?.review_analysis || '',
        review_challenge: redGroup?.review_analysis || redGroup?.reason || '',
        review_evidence_strength: redGroup?.evidence_strength,
        mappings: blueMappings.map((blueMapping: any, index: number) => {
            const redMapping = redMappings[index] || {};
            const reviewAnalysis = redMapping.review_analysis ?? redGroup?.review_analysis ?? '';
            const redReason = getRedReason(redMapping, redGroup, index);

            return {
                ...blueMapping,
                reason: redReason,
                mapping_label: redMapping.mapping_label ?? redGroup?.mapping_label,
                review_action: redMapping.review_action ?? redGroup?.review_action,
                review_analysis: reviewAnalysis,
                review_challenge: redMapping.review_challenge ?? (reviewAnalysis || redReason),
                review_evidence_strength: redMapping.review_evidence_strength ??
                    redMapping.evidence_strength ??
                    redGroup?.evidence_strength,
            };
        }),
    };
};
